import React from "react";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import i18n from "../../../../i18n/i18n";
import TicketForm from "../ticketForm/ticketForm";

export default class AddTicket extends React.Component {
    render() {
        return (
            <AddItem
                class="add-ticket"
                header={i18n.t("transportation.ticket.addTicket.header")}
                content={<TicketForm isUpdate={false}/>}
            />
        );
    }
}